import { MappingConfig } from './mapping-config';

/**
 * Mapping configuration corresponding to an empty mapping
 */
export class MappingEmptyConfig extends MappingConfig {}
